import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '职业选手苏屠 · 回馈新老粉丝福利' },
  },
  {
    path: '/task/:key',
    name: 'task-category',
    // 分类页按 key 懒加载同一个视图
    component: () => import(/* webpackChunkName: "task" */ '../views/TaskCategoryView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
